import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SearchService {
  public phoneNumberSubject = new BehaviorSubject<any>(null);
  public resetFeild = new Subject<any>();

  constructor() {}

  searchPhoneNo(data: any) {
    this.phoneNumberSubject.next(data);
  }

  getSearchPhoneNo() {
    return this.phoneNumberSubject.asObservable();
  }
}
